import _ from "lodash";

export const stringToNumber = (raw) => {
  if (!raw) return null;

  return typeof raw == 'string'
    ? parseFloat(raw?.replace(',', '.'))
    : _.toNumber(raw);
}
